const HeaderLayout = ({ logo }) => {
  return (
    <header className="mx-auto mt-8">
      <img
        src={logo?.localFile?.url}
        style={{ aspectRatio: `${logo?.width}/${logo?.height}` }}
        className="max-w-[194px] sm:max-w-[263px]"
      />
    </header>
  )
}

export default HeaderLayout
